import type { I18nT } from "@lib/dashboardI18n";
import type { NavigationRoutingObject } from "@navigationRouting/types";

export const toolsDashboardNRO: NavigationRoutingObject = {
  section: "braze-tools",
  heading: (t: I18nT<"dashboard-navigation">) => t("tools-dashboard-sidebar-pill-menu-option", "Tools Dashboard"),
  description: (t: I18nT<"dashboard-navigation">) =>
    t(
      "tools-dashboard-description-nav",
      "Access internal tools such as feature flippers, debugging tools, company management, and more"
    ),
  icon: "nav-system-tools",
  getDeveloperNavigationAllowed: ({ isInternalDeveloper }) => {
    return isInternalDeveloper;
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
};
